import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const setElementScrollLeft = (element, value)=>{
    element.scrollLeft = value;
};
const Tabs = ({ children , onChange , activeTabIndex , variant ='primary' , 'data-t': dataT ,  })=>{
    const tabsRef = React.useRef(null);
    const activeTabRef = React.useRef(null);
    const [isScrolling, setIsScrolling] = React.useState(false);
    React.useEffect(()=>{
        const setScrolling = (current)=>{
            const { offsetWidth , scrollWidth  } = current;
            offsetWidth < scrollWidth ? setIsScrolling(true) : setIsScrolling(false);
        };
        const onResize = ()=>{
            if (!tabsRef.current) {
                return;
            }
            setScrolling(tabsRef.current);
        };
        if (tabsRef.current) {
            setScrolling(tabsRef.current);
            window.addEventListener('resize', onResize);
            activeTabRef.current && setElementScrollLeft(tabsRef.current, activeTabRef.current.offsetLeft);
        }
        return ()=>window.removeEventListener('resize', onResize)
        ;
    }, [
        tabsRef.current
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "tabs__wrapper",
        "data-t": dataT
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(`tabs tabs--${variant}`, {
            'tabs--scrolling': isScrolling
        }),
        ref: tabsRef
    }, React.Children.map(children, (child, index)=>{
        if (/*#__PURE__*/ React.isValidElement(child)) {
            return /*#__PURE__*/ React.cloneElement(child, {
                onClick: ()=>{
                    onChange && onChange(index);
                    child.props.onClick && child.props.onClick();
                },
                isActive: activeTabIndex === index,
                variant
            });
        }
    }), isScrolling && /*#__PURE__*/ React.createElement(Icon, {
        className: "tabs__scroll-icon",
        name: "chevron-right"
    })));
};

export { Tabs as default, setElementScrollLeft };
//# sourceMappingURL=Tabs.js.map
